export default "__VITE_ASSET__3xNgHwXt__"